<script>
	import Router, { push, location } from "svelte-spa-router";
	import NotFound from "./routes/NotFound.svelte";
	import { onMount } from "svelte";
	import { firebaseConfig, authAPI } from "./config";
	import Home from "./routes/Home.svelte";
	import Page from "./routes/Page.svelte";
	import { donationboxes } from "./stores";
	import New from "./routes/New.svelte";
	import Login from "./routes/Login.svelte";
	import Cookies from "js-cookie";
import AuthCheck from "./routes/AuthCheck.svelte";

	export let dftCookie;
	export let dftUrl;

	let db;
	let user;
	let authed = false;

	const routes = {
		"/": AuthCheck,
		"/home": Home,
		"/new": New,
		"/login": Login,
		"/page/:id": Page,
		"*": NotFound,
	};

	async function logIntoFs(ct) {
		return firebase
			.auth()
			.signInWithCustomToken(ct)
			.then((userCredential) => {
				// Signed in
				user = userCredential.user;
				// ...
			})
			.catch((error) => {
				var errorCode = error.code;
				var errorMessage = error.message;
				// ...
			});
	}
	async function getFsCustomToken(jwtToken) {
		return fetch(authAPI + "/signintofs?token=" + jwtToken)
			.then((response) => response.json())
			.then(async (data) => {
				await setCookies(data.d, data.dfp);
				return data;
			});
	}

	async function setCookies(d, dfp) {
		Cookies.set("dfak", dfp.api_key);
		Cookies.set("dfusername", d[0]);
		localStorage.setItem("lportal", d[1]);
		localStorage.setItem("portal", d[2]);
		localStorage.setItem("dfp", JSON.stringify(dfp));
	}

	async function doAuthFlow(dft) {
		user = firebase.auth().currentUser;
		if (!user) {
			getFsCustomToken(dft)
				.then(async (retTok) => {
					await logIntoFs(retTok.token);
				})
				.catch((e) => {
					console.log(e);
				});
		}
		db = firebase.firestore();
	}

	onMount(async () => {
		
		if (!firebase.apps.length) {
				firebase.initializeApp(firebaseConfig);
			}
			if (!dftCookie) {
				// If no cookie token, then use token in URL:
				if (dftUrl) {
					Cookies.set("dft", dftUrl);
					await doAuthFlow(dftUrl);
					window.location.reload(true);
					// await getContent();	
				} else {
					push("/login");
				}
			} else {
				doAuthFlow(dftCookie).then( async () => {
					authed = true;
				});
			}
	});
</script>

{#if authed || $location === "/login"}
	<Router {routes} />
{/if}
